module.exports = __webpack_public_path__ + "static/img/ltc-peru.e5fdc08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/content-layout/assets/img/ltc-peru.svg
// module id = HUtK
// module chunks = 95